import TextStyling from './TextStyling';

const RentGuaranteeDisclaimer = ({ header = '', description = [] } = {}) => ({
  header: String(header),
  description: description.map((item) => TextStyling(item)),
});

const RentGuaranteeDisclaimers = ({ disclaimers = [] } = {}) => ({
  disclaimers: disclaimers.map((disclaimer) => RentGuaranteeDisclaimer(disclaimer)),
});

export default RentGuaranteeDisclaimers;
